export class LoanCreateModel {
  quoteId: any;
  repayMethod: string;
  terminalId: string;
  mandateRef?: string | null;
  loanNo?: number
}
